import React from 'react';
import { platformName, supportEmail } from '../lib/site';

export const errText = (e, f = 'Something went wrong') => { const d = e?.response?.data?.detail; return Array.isArray(d) ? d.map((x) => x.msg).join('; ') : (typeof d === 'string' ? d : f); };

export const AuthShell = ({ title, subtitle, children, footer, testId }) => (
  <div data-testid={testId} style={{ minHeight: '100vh', background: '#0B1120', color: '#E2E8F0', display: 'grid', placeItems: 'center', padding: 24, fontFamily: 'Inter, system-ui, sans-serif' }}>
    <div style={{ width: '100%', maxWidth: 460 }}>
      <a href="/" style={{ color: '#fff', fontWeight: 800, fontSize: 22, textDecoration: 'none', letterSpacing: '-0.02em' }} data-testid="auth-brand">{platformName()}</a>
      <div style={{ marginTop: 18, background: '#111827', border: '1px solid #1F2937', borderRadius: 16, padding: 28 }}>
        <h1 style={{ margin: 0, fontSize: 24, fontWeight: 800 }}>{title}</h1>
        {subtitle && <p style={{ margin: '6px 0 20px', color: '#94A3B8', fontSize: 14 }}>{subtitle}</p>}
        {children}
      </div>
      {footer && <p style={{ marginTop: 16, fontSize: 13, color: '#94A3B8', textAlign: 'center' }}>{footer}</p>}
      {supportEmail() && <p style={{ marginTop: 6, fontSize: 12, color: '#64748B', textAlign: 'center' }}>Need help? {supportEmail()}</p>}
    </div>
  </div>
);

export const input = { width: '100%', background: '#0B1120', border: '1px solid #334155', borderRadius: 10, color: '#fff', padding: '11px 12px', fontSize: 14, marginTop: 6, boxSizing: 'border-box' };
export const label = { display: 'block', fontSize: 12, fontWeight: 600, color: '#CBD5E1', textTransform: 'uppercase', letterSpacing: '0.08em', marginTop: 14 };
export const primary = { width: '100%', marginTop: 22, background: '#4F46E5', color: '#fff', border: 'none', borderRadius: 10, padding: '12px 16px', fontSize: 15, fontWeight: 700, cursor: 'pointer' };
export const link = { color: '#A5B4FC', textDecoration: 'none', fontWeight: 600 };

export const Field = ({ id, type = 'text', value, onChange, placeholder, children, ...rest }) => (
  <label style={label}>{children}<input data-testid={id} type={type} value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} style={input} {...rest} /></label>
);
